import { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { ICustomDictionaryItem } from '~/services/api/dictionaries/types';
import DictionaryActionTYPE from '../enums/dictionaryActionTypes';

export interface IDictionaryItemAction {
  actionType: DictionaryActionTYPE | null;
  dictionaryItem: ICustomDictionaryItem | null;
  setDictionaryItem: Dispatch<SetStateAction<ICustomDictionaryItem | null>>;
  onAddDictionaryItem: () => void;
  onEditDictionaryItem: (item: ICustomDictionaryItem) => void;
  onClose: () => void;
}

const useDictionaryItemAction = (): IDictionaryItemAction => {
  const [actionType, setActionType] = useState<DictionaryActionTYPE | null>(null);
  const [dictionaryItem, setDictionaryItem] = useState<ICustomDictionaryItem | null>(null);

  const onAddDictionaryItem = useCallback((): void => {
    setActionType(DictionaryActionTYPE.add);
    setDictionaryItem({} as ICustomDictionaryItem);
  }, []);

  const onEditDictionaryItem = useCallback((item: ICustomDictionaryItem): void => {
    setActionType(DictionaryActionTYPE.edit);
    setDictionaryItem(item);
  }, []);

  const onClose = useCallback((): void => {
    setActionType(null);
    setDictionaryItem(null);
  }, []);

  return {
    actionType,
    dictionaryItem,
    setDictionaryItem,
    onAddDictionaryItem,
    onEditDictionaryItem,
    onClose,
  };
};

export default useDictionaryItemAction;
